import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tablist', 'tab', 'tabpanel']
  static values = { id: String }

  connect() {
    const { hash } = window.location
    let targetId = null

    if (hash) {
      const [namespace, id] = hash.replace('#', '').split('--')
      if (namespace === this.idValue) targetId = id
    }

    const hasMatchingTab = this.#findTabById(targetId)

    this.#activateTab(
      false,
      hasMatchingTab ? targetId : this.tabTargets[0].dataset.tabId,
      // Don't update the URL hash on page load since it causes problems when
      // there are multiple tabs controllers. We also don't want to override
      // any non-tabs hashes
      { updateURL: false }
    )
  }

  toggleTab(event) {
    this.#activateTab(event, event.currentTarget.dataset.tabId)
  }

  #activateTab(event, id = null, options = {}) {
    const defaultOptions = { updateURL: true }
    options = { ...defaultOptions, ...options }

    // If no matching tab is found, default to the first tab
    if (!this.#findTabById(id)) id = this.tabTargets[0].dataset.tabId

    this.tabTargets.forEach(tab => {
      const active = tab.dataset.tabId === id
      tab.ariaSelected = active
    })

    this.tabpanelTargets.forEach(tabpanel => {
      const active = tabpanel.dataset.tabId === id
      tabpanel.ariaExpanded = active
    })

    if (!options.updateURL || !this.idValue) return

    // append namespaced tab ID hash to URL and add it to the browser's history
    const newURL = new URL(window.location)
    newURL.hash = `${this.idValue}--${id}`
    window.history.pushState(null, '', newURL)
  }

  #findTabById(id) {
    return this.tabTargets.find(tab => tab.dataset.tabId === id)
  }
}
